import { useCallback } from 'react';
import { usePartner } from '../../PartnerContext';
import { APIPartnerReferral } from '../../api_partner';
import ReferralBlock from './ReferralBlock';

export default function PartnerReferralCard() {
  const { partnerToken } = usePartner();
  const fetcher = useCallback(() => APIPartnerReferral(partnerToken), [partnerToken]);
  if (!partnerToken) return null;
  return <ReferralBlock fetcher={fetcher} />;
}